import { useEffect } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { SignUp, useAuth } from "@clerk/react";
import AppShell from "@/components/AppShell";
import { MEMBERS_START_NOTE, NZ_GST_NOTE, PRICING } from "@/lib/content";
import { PriceCard } from "@/components/PriceCard";
import { AuthLayout } from "@/pages/AuthPages";

const PLAN_PARAM = { free: "free", monthly: "ahu_monthly", annual: "ahu_annual" };

export const nextForIntent = (intent) =>
  intent === "ahu_monthly" || intent === "ahu_annual" ? `/membership?plan=${intent}` : intent === "choose" ? "/choose" : null;

const BTN = {
  free: ["btn-gold", "journey-start-free-btn"],
  ahu_monthly: ["btn-charcoal", "journey-monthly-btn"],
  ahu_annual: ["btn-outline", "journey-annual-btn"],
};

export function ChooseOption() {
  const nav = useNavigate();
  const choose = (id) => {
    localStorage.removeItem("ahu_intent");
    nav(id === "free" ? "/" : `/membership?plan=${id}`);
  };
  return (
    <AppShell nav={false}>
      <div className="fade-in" data-testid="choose-option-page">
        <p className="eyebrow mb-3">Choose how to start</p>
        <h1 className="text-3xl sm:text-4xl leading-tight">Your first plan is free</h1>
        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {PRICING.filter((p) => p.id !== "free").map((p) => (
            <PriceCard key={p.id} p={p} selected={p.id === "ahu_monthly"}>
              <button className={`${BTN[p.id][0]} w-full sm:w-auto`} onClick={() => choose(p.id)} data-testid={BTN[p.id][1]}>{p.join}</button>
            </PriceCard>
          ))}
        </div>
        <div className="mt-8 ahu-card p-6" data-testid="choose-free-panel">
          <p className="text-charcoal" data-testid="choose-free-note">Not ready for membership? Your first Action Plan is free, and no payment is taken for it.</p>
          <button className="btn-gold mt-4 w-full sm:w-auto" onClick={() => choose("free")} data-testid={BTN.free[1]}>Start your free plan</button>
        </div>
        <p className="mt-4 text-sm font-medium text-charcoal" data-testid="journey-no-charge-note">{MEMBERS_START_NOTE}</p>
        <p className="mt-2 text-sm text-ink-soft" data-testid="journey-gst-note">{NZ_GST_NOTE}</p>
        <p className="mt-2 text-sm text-ink-soft"><Link to="/notify" className="underline underline-offset-4" data-testid="journey-notify-link">Outside New Zealand? Register your interest for when membership becomes available in your region.</Link></p>
      </div>
    </AppShell>
  );
}

export default function Start() {
  const { isLoaded, isSignedIn } = useAuth();
  const [params] = useSearchParams();
  const plan = params.get("plan");

  useEffect(() => {
    if (isLoaded && !isSignedIn && (plan || !localStorage.getItem("ahu_intent") || window.location.pathname === "/start"))
      localStorage.setItem("ahu_intent", PLAN_PARAM[plan] || "choose");
  }, [isLoaded, isSignedIn, plan]);

  if (isLoaded && isSignedIn) return <Navigate to="/" replace />;
  return (
    <AuthLayout testId="start-page">
      <p className="mb-4 text-sm text-ink-soft text-center max-w-[400px]" data-testid="start-adults-note">AHU is for adults 18 and over.</p>
      <SignUp routing="path" path="/start" signInUrl="/sign-in" forceRedirectUrl="/" appearance={{ elements: { footerAction: { display: "none" } } }} />
      <p className="mt-6 text-[15px] text-ink-soft" data-testid="start-signin-note">
        Already have an account? <Link to="/sign-in" className="btn-quiet" data-testid="journey-signin-link">Sign in</Link>
      </p>
    </AuthLayout>
  );
}
